import ListingHeader from "../../../components/listingHeader/listingHeader";
import SBEditable from "../../../components/sbEditable/sbEditable";
import styles from "./anchorPanel.module.scss";
import { SVGIconKeyToComponent } from "../../../helpers/datasourceHelpers";
import { RenderStoryblokComponent } from "../../../helpers/bloksRenderer";

/// Blok:anchorPanel
// anchor:blok
///
/// header:string
/// header_underline_color:string
/// content:anchor
function AnchorPanel({ blok, story_language }) {
  return (
    <SBEditable blok={blok} withId={blok.anchor}>
      <div className={`richtext ${styles.root}`}>
        {blok.header || blok.header_icon ? (
          <ListingHeader underlineColor={blok.header_underline_color}>
            <h2>
              {blok.header}
              <span className={styles.icon}>
                {SVGIconKeyToComponent(blok.header_icon)}
              </span>
            </h2>
          </ListingHeader>
        ) : null}
        <div
          className={
            `${styles.contentContainer}` +
            (blok.text_padding_right ? ` ${styles.paddingRight}` : "")
          }
        >
          {blok.content ? blok.content.map((itemBlok) => RenderStoryblokComponent(itemBlok, null, story_language)) : null}
        </div>
      </div>
    </SBEditable>
  );
}

export default AnchorPanel;
